import React, {Component} from 'react';
import * as func from "../../../../utils/functions";
import MailHistoryDetail from "./detail";
import MLItem from "./item/mlitem";
import {BASE_PATH} from "../../../../wpconfig";
import {objectToQueryString, pushUrl} from "../../../../utils/functions";
import ReactPaginate from "react-paginate";

class mailHistory extends Component {
  constructor(props) {
    super(props);
    const p = func.parseParams(location.search.substring(1))

    this.state = {
      isInit: false,
      param: {
        'current_page' : p['current_page'] ? p['current_page'] : 1,
        'record_id' : p['record_id'] ? p['record_id'] : '',
      },
      records: [],
      totalRecords: 0,
      totalPage: 0,
      action : 'sendmail/history/list',
      url: 'wp-admin/admin.php?page=researchmind-analysis&tab_id=mailHistory&',
    }
  }
  componentDidMount() {
    // 이해 안됨.
    setTimeout(() => {
      this.getList({}, true)
    }, 0);
  }

  getList(param = {}, isInit = false) {
    if(Object.keys(param).length > 0) {
    } else {
      param = this.state.param
    }

    func.getData(this.state.action, param).then((response) => {
      const p = {
        records: response.records,
        totalRecords: response.pageInfo.totalResults,
        totalPage: response.pageInfo.totalPage,
      }
      if(isInit) {
        p['isInit'] = true
      } else {
        const url = objectToQueryString(this.state.param);
        pushUrl('검색', BASE_PATH + this.state.url + url, this.state.param);
      }
      this.setState(p)
    });
  }
  handlePageClick = (page) => {
    const paged = page.selected + 1;

    let param = this.state.param;
    param['current_page'] = paged;

    this.setState(param)

    this.getList(param);
  }

	render() {
    if(this.state.param.record_id) {
      return (<MailHistoryDetail />)
    } else {
      return (
        <div className="container-fluid mt-3 admin-layout">
          <div className="row">
            <div className="col admin-contents">
              <table className="table table-striped table-thin border-bottom sendmail-history-list">
                <thead>
                <tr>
                  <th scope="col">ID</th>
                  <th scope="col">제목</th>
                  <th scope="col">논문수</th>
                  <th scope="col">발송건수</th>
                  <th scope="col">실패건수</th>
                  <th scope="col">수신거부</th>
                  <th scope="col">메일유형</th>
                  <th scope="col">작업자</th>
                  <th scope="col">발송일자</th>
                </tr>
                </thead>
                <tbody>
                {!this.state.isInit && this.state.records.length <= 0 && <tr>
                  <td colSpan={16}>로딩중입니다.</td>
                </tr>}
                {this.state.isInit && this.state.records.length <= 0 && <tr>
                  <td colSpan={16}>결과가 없습니다.</td>
                </tr>}
                {this.state.records.map((record, index) => {
                  return (
                    <MLItem key={record.ID} record={record} url={BASE_PATH + this.state.url} />
                  )
                })}
                </tbody>
              </table>
              {this.state.totalPage > 1 &&
                <div className="mt-4">
                  <div>
                    <div className="paging-wrap">
                      <ReactPaginate
                        forcePage={Number(this.state.param.current_page) - 1}
                        pageCount={this.state.totalPage}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={this.handlePageClick}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                        pageClassName={'page-item'}
                        pageLinkClassName={'page-link'}
                        previousClassName={'page-item page-item-prev'}
                        previousLinkClassName={'page-link'}
                        nextClassName={'page-item page-item-next'}
                        nextLinkClassName={'page-link'}
                      />
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      )
    }
	}
}

export default mailHistory;
